export type PdfOutputMode = "buffer" | "file";

export type PdfEngineErrorCode =
  | "VALIDATION_ERROR"
  | "BROWSER_NOT_FOUND"
  | "BROWSER_LAUNCH_FAILED"
  | "ASSET_LOAD_FAILED"
  | "RENDER_FAILED"
  | "TIMEOUT"
  | "FILE_OUTPUT_FAILED";

export type BrowserSource = "override" | "chrome" | "edge" | "bundled";

export type CssLength = string;

export type PdfPageSize = {
  width: CssLength;
  height: CssLength;
};

export type PdfMargins = {
  top?: CssLength;
  right?: CssLength;
  bottom?: CssLength;
  left?: CssLength;
};

export type RenderPdfOptions = {
  html: string;
  size: PdfPageSize;
  margins?: PdfMargins;
  landscape?: boolean;
  output?: PdfOutputMode;
  outputPath?: string;
  scale?: number;
  timeout?: number;
  executablePath?: string;
};

export type NormalizedRenderPdfOptions = {
  html: string;
  size: PdfPageSize;
  margins?: Required<PdfMargins>;
  landscape?: boolean;
  output: PdfOutputMode;
  outputPath?: string;
  scale: number;
  timeout: number;
  executablePath?: string;
};

export type RenderPdfFileResult = {
  path: string;
};

export type RenderPdfResult = Buffer | RenderPdfFileResult;

export type DetectedBrowser = {
  name: string;
  source: BrowserSource;
  executablePath: string;
};

export type AssetLoadFailure = {
  url: string;
  errorText: string;
};

export type PdfEngineErrorOptions = {
  cause?: unknown;
  details?: unknown;
};

export class PdfEngineError extends Error {
  readonly code: PdfEngineErrorCode;
  readonly details?: unknown;

  constructor(
    code: PdfEngineErrorCode,
    message: string,
    options: PdfEngineErrorOptions = {}
  ) {
    super(message);
    this.name = "PdfEngineError";
    this.code = code;

    if ("cause" in options) {
      this.cause = options.cause;
    }

    if ("details" in options) {
      this.details = options.details;
    }
  }
}
